import styled from 'styled-components';
import ForwardArrowIcon from '../assets/arrow-next-right-icon.svg?react';

export const ForwardArrow = styled(ForwardArrowIcon)`
  padding-left: 5px;
  width: 12px;
  fill: var(--color-text-light);
`;
